import { render, staticRenderFns } from "./GPathProductList.vue?vue&type=template&id=6e63cf73&scoped=true"
import script from "./GPathProductList.vue?vue&type=script&lang=js"
export * from "./GPathProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e63cf73",
  null
  
)

export default component.exports